const { renderReady, render, initGlobalWindowEbayObject } = require('../../src/utils');

module.exports = class {
    onCreate(input) {
        const { width, height } = this.getSize(input);

        this.state = {
            placementId: input.placementId,
            module: input.module,
            docId: `placement${input.placementId}`,
            options: input.options,
            shimmerWidth: width,
            shimmerHeight: height,
            style: this.getStyle(width, height),
        };
    }

    onInput(input) {
        if (this.state.module !== input.module) {
            const { width, height } = this.getSize(input);

            this.state.module = input.module;
            this.state.options = input.options;
            this.state.shimmerWidth = width;
            this.state.shimmerHeight = height;
            this.state.style = this.getStyle(width, height);
            this.beginRendering();
        }
    }

    onMount() {
        initGlobalWindowEbayObject();
        this.beginRendering();
    }

    beginRendering() {
        this.initiateHTMLModuleRendering(this.state.module);
    }

    initiateHTMLModuleRendering(module) {
        if (module && Object.keys(module).length > 0) {
            const skeletonId = (this.state.options && this.state.options.skeletonId) ? this.state.options.skeletonId : undefined;
            renderReady(module).then(() => {
                render(module, this.state.docId, document, skeletonId);
            });
        }
    }

    getSize(input) {
        const size = input.module ? input.module.size : undefined;

        if (typeof size === 'object' && (!isNaN(size.width) || !isNaN(size.height))) {
            return {
                width: size.width,
                height: size.height,
            };
        }

        if (input.options) {
            return {
                width: input.options.width,
                height: input.options.height,
            };
        }

        return {
            width: undefined,
            height: undefined,
        };
    }

    getStyle(width, height) {
        if (width <= 0 || !height || height <= 0) {
            return;
        }

        return `${width ? `min-width:${width}px;` : ''}min-height:${height}px;`;
    }
};
